import { render, staticRenderFns } from "./ClientsAdd.vue?vue&type=template&id=025eb757&"
import script from "./ClientsAdd.vue?vue&type=script&lang=js&"
export * from "./ClientsAdd.vue?vue&type=script&lang=js&"
import style0 from "./ClientsAdd.vue?vue&type=style&index=0&id=025eb757&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports